// extracted by mini-css-extract-plugin
export default {"head":"PartnerRegisteration_head__ZW+it"};